module.exports = __webpack_public_path__ + "media/images/flags/32/Barbados-f904e0379b0002b8ccc6e73ba8a9e374.png";